<template>
    <div class="newintro">
    <div class="newintro__container">
      <h1 class="newintro__headline">Rewolucyjna książka kucharska</h1>
      <div class="newintro__line"></div>
      <h2 class="newintro__subtitle">czyli przepisy<br> na lepszą<br> Polskę</h2>
   
    </div>
      <div class="newintro__links">
       <a href="#dishes-slider" class="newintro__more">Więcej</a>
       <div @click="openInvitation" class="newintro__order">Zamów</div>
     </div>
      <a href="#future">
         <img src="@/assets/images/icons/chevron-down.svg" class="newintro__scroll" alt="" />
    </a>
  </div>
</template>

<script>
export default {
  name: "Introrew",
  data() {
    return {
      title: "Introrew",
    };
  },
  components: {},
  inject: [],
    methods: {
    openInvitation(){
       this.$root.$emit("toggleModalInvitation", true);
    }
  },
};
</script>
